
<div id="container">


    <mat-card class="login-card" *ngIf="visibleCard == 'FORGOT'">
        <fortgot-password [(visibleCard)]="visibleCard"></fortgot-password>
    </mat-card>

    <mat-card class="login-card" *ngIf="visibleCard == 'REGISTER'">
        <register [(visibleCard)]="visibleCard"></register>
    </mat-card>

    <mat-card class="login-card" *ngIf="visibleCard == 'LOGIN'">
        <h1>Login</h1>
        <form [formGroup]="loginForm">

            <mat-form-field appearance="outline" >
                <mat-label>E-Mail Adresse</mat-label>
                <input matInput type="email" email formControlName="email" required placeholder="E-Mail Adresse">
            </mat-form-field>


            <!--password input filed-->
            <mat-form-field appearance="outline">
                <mat-label>Password</mat-label>
                <input matInput #password type="password" formControlName="password" required placeholder="Passwort">
            </mat-form-field>
            <div class="ac-captcha-hint">
                This site is protected by reCAPTCHA and the Google
                <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                <a href="https://policies.google.com/terms">Terms of Service</a> apply.
            </div>
            <re-captcha *ngIf="showV2Captcha" (resolved)="resolvedV2($event)" siteKey="6Lcy88QZAAAAAPz1D7oYXsuJidA7ZBTuQ00-KTKO"></re-captcha>
            <div class="button-container" *ngIf="!showV2Captcha">
                <button [disabled]="!loginForm.valid" matRipple  mat-flat-button color="primary" (click)="executeImportantAction()"><mat-icon aria-hidden="false">lock</mat-icon>Login</button>
            </div>
            
        </form>

        <div class="mdc-layout-grid__inner card-footer">
            <div class="mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-2-phone" style="padding-top: 8px; text-align: left;">
                <a href="#" (click)="visibleCard = 'FORGOT'" style="text-decoration: none;">Passwort vergessen?</a>
            </div>
            <div class="mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-2-phone" style="padding-top: 8px; text-align: right;">
                <a href="#" (click)="visibleCard = 'REGISTER'" style="text-decoration: none;">Registrieren</a>
            </div>
        </div>
    </mat-card>
</div>



<!--<button (click)="login()" *ngIf="!isLoggedin">Login</button>
<button (click)="logout()" *ngIf="isLoggedin">Logout</button>
<button (click)="getOverview()">GetOverview</button>
<button (click)="getProfile()">getProfile</button>-->